/**
 * Collection of host constants used across the application.
 * This file defines the known hostnames for different environments (e.g., development, local).
 *
 * Usage of these constants helps ensure consistent host checking and improves maintainability.
 */

// type HostPaths = (typeof HOSTS)[keyof typeof HOSTS];

const HOSTS = {
	LOCALHOST: "localhost",
	LOCALHOST_IP: "127.0.0.1",
} as const;

const DEV_HOSTS: string[] = [HOSTS.LOCALHOST, HOSTS.LOCALHOST_IP];

export { HOSTS, DEV_HOSTS };
